import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { UserDetails } from 'src/app/user-profile/models/userdetails.model';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../logger/logger.service';
import { map } from '@progress/kendo-data-query/dist/npm/transducers';
import { catchError } from 'rxjs/operators';
import { EventsLogin } from './events-login.Model';

@Injectable({
    providedIn: 'root'
})
export class UserInfoService {

    baseurl = environment.baseUrlParties;
    private userInfo = {
        name: '',
        skillLevel: 'newbie'
        // set the skillLevel to 'expert' for expertview blueprint functionality
    };
    private userInfoSubject: BehaviorSubject<any> = new BehaviorSubject<any>(this.userInfo);
    userInfo$: Observable<any> = this.userInfoSubject.asObservable();

    constructor(
        private loggerService: LoggerService,
        private httpClient: HttpClient
    ) { }

    getUserInfo() {
        return this.userInfo$;
    }
    public getPartyInfo(): Observable<UserDetails> {
        return this.httpClient.get<UserDetails>(this.baseurl);
    }

    public savePartyDetails(userDetail: any) {
        return this.httpClient.put(this.baseurl, userDetail);
    }

    public logIn() {
        return this.httpClient.post<EventsLogin>(`${this.baseurl}/me/events/login`, {});
    }

    public logOut() {
        return this.httpClient.post(`${this.baseurl}/events/logout`, {});
    }

/*    public getPartyInfo(partyId: string) {
        const url = this.baseurl + partyId;
        return this.httpClient.get<UserDetails>(url).pipe();
    }*/
}
